const genericMessage = 'Ocorreu um erro inesperado. Tente mais tarde'
const unauthorizedMessage =
    'Você não tem permissão para realizar esta ação. Entre em contato com o administrador da sua organização'

export default class ErrorHandler {
    static handleError = (error, aditionalMessage) => {
        if (ErrorHandler.isUnauthorized(error)) {
            error.message = unauthorizedMessage
            if (aditionalMessage) console.error(aditionalMessage)
            throw error
        }
        error.message = genericMessage
        if (aditionalMessage) console.error(aditionalMessage)
        throw error
    }

    static isUnauthorized(error) {
        return error && error.response && error.response.status === 403
    }
}
